export const convertToNumber = (value: string | number | undefined | null): number => {
  if (!value) return 0.0
  if (typeof value === 'number') return value

  const sanitizedValue = value.replace(',', '.')
  const parsedValue = parseFloat(sanitizedValue)
  return isNaN(parsedValue) ? 0.0 : parsedValue
}
